module.exports = __webpack_public_path__ + "img/taken_distribution.6d02dfa5.svg";